export default __webpack_public_path__ + "static/media/schedule.ff6759f0.png";